<template>
  <div class="integracion-expediente-principal" style="flex-grow: 1">
    <modal-pdf :urlDocumento="urlPdf"></modal-pdf>
    <!-- Modal anotar observación -->
    <div
      class="modal fade"
      id="modalObservacion"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header modal-observacion__header">
            <h5 class="modal-title modal-observacion__titulo">
              Ingresa una observación
            </h5>
          </div>
          <div class="modal-body modal-observacion__cuerpo">
            <label
              v-if="ObservacionArchivo != null"
              class="modal-observacion__etiqueta"
              >Obervación actual:
            </label>
            <textarea
              class="form-control modal-observacion__texto"
              v-model="Observacion.motivoObservacion"
              rows="2"
            ></textarea>
          </div>
          <div class="modal-footer modal-observacion__footer">
            <button
              type="button"
              class="btn boton-transparente modal-observacion__boton"
              data-bs-dismiss="modal"
              ref="botoncerrarObservacion"
              @click.prevent="LimpiarCamposModal()"
            >
              Cancelar
            </button>
            <button
              v-if="enviandoObservacion"
              type="button"
              disabled
              class="btn boton-primario modal-observacion__boton"
            >
              <v-progress-circular
                indeterminate
                size="25"
                color="primary"
              ></v-progress-circular>
            </button>
            <button
              v-else-if="enviandoObservacion == false"
              type="button"
              @click.prevent="EnviarObservacionArchivo"
              class="btn boton-primario modal-observacion__boton"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
    <TituloSeccion titulo="PRE AUTORIZACIÓN"></TituloSeccion>
    <div class="container contenedor-preautorizacion">
      <div class="row col-lg-12" style="text-align: left">
        <p class="parrafo-instrucciones mt-2">
          Revisa los documentos cargados y agrégales una observación en caso de
          que requieran una mejora o cambio.
        </p>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Persona: <strong> {{ tipoCliente }} </strong></label
          >
        </div>

        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Sucursal: <strong> {{ datosEmbajador.sucursal }} </strong></label
          >
        </div>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Nombre: <strong> {{ nombreCliente }} </strong></label
          >
        </div>

        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Embajador: <strong> {{ datosEmbajador.nombre }} </strong></label
          >
        </div>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Valor de la propiedad:
            <strong> {{ DarFormatoMoneda(montoPropiedad) }} </strong></label
          >
        </div>

        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Contacto embajador:
            <strong> {{ datosEmbajador.correo }} </strong></label
          >
        </div>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Alta: <strong> {{ FechaAltaProspecto }} </strong></label
          >
        </div>

        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Preautorizacion:
            <strong> {{ FechaPreautorizacion }} </strong></label
          >
        </div>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Generacion pago:
            <strong> {{ FechaGeneracionPago }} </strong></label
          >
        </div>

        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Tipo de inmueble: <strong> {{ TipoInmueble }} </strong></label
          >
        </div>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Uso del inmueble: <strong> {{ UsoInmueble }} </strong></label
          >
        </div>

        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Tipo de ubicación: <strong> {{ TipoUbicacion }} </strong></label
          >
        </div>
      </div>

      <div class="row col-lg-12" style="text-align: left">
        <div class="col-lg-6" style="text-align: left">
          <label class="float-left mb-2"
            >Estado inmueble: <strong> {{ Estado }} </strong></label
          >
        </div>
      </div>

      <div class="table-responsive">
        <table class="table tabla-preautorizacion">
          <thead class="encabezado-tabla">
            <tr>
              <th scope="col">Documento</th>
              <th scope="col">Archivo</th>
              <th scope="col">Acciones</th>
              <th scope="col">Observación</th>
              <th scope="col">Aprobar</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="texto-tabla">Solicitud de inscripción</td>
              <td>
                <label
                  class="texto-tabla-obs text-left"
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  @click.prevent="cargarSolicitud()"
                >
                  Ver/editar solicitud de inscripción
                </label>
                <label
                  v-else
                  class="texto-tabla-obs text-left"
                  @click.prevent="cargarSolicitud()"
                >
                  Ver solicitud de inscripción
                </label>
              </td>
              <td>-</td>
              <td v-if="ObservacionSolicitudPersonaFisica != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="ObservacionSolicitud(true)"
                >
                  Ver Observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Ver Observación
                </label>
              </td>
              <td v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  class="texto-tabla-obs"
                  @click.prevent="ObservacionSolicitud(false)"
                >
                  + Agregar una observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  + Agregar una observación
                </label>
              </td>
              <td v-if="ObservacionSolicitudPersonaFisica != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  @click.prevent="AprobarSolicitud()"
                >
                  Aprobar
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Aprobar
                </label>
              </td>
            </tr>
            <tr v-if="tipoPersona == 1" class="mt-3">
              <td class="texto-tabla">
                Solicitud de inscripción (Representante legal)
              </td>
              <td>
                <label
                  class="texto-tabla-obs text-left"
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  @click.prevent="cargarSolicitudRepresentante()"
                >
                  Ver/editar solicitud de inscripción
                </label>
                <label
                  v-else
                  class="texto-tabla-obs text-left"
                  @click.prevent="cargarSolicitudRepresentante()"
                >
                  Ver solicitud de inscripción
                </label>
              </td>
              <td>-</td>
              <td v-if="ObservacionSolicitudRepresentanteLegal != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  class="texto-tabla-obs"
                  @click.prevent="ObservacionSolicitudRepresentante(true)"
                >
                  Ver Observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Ver Observación
                </label>
              </td>
              <td v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="ObservacionSolicitudRepresentante(false)"
                >
                  + Agregar una observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  + Agregar una observación
                </label>
              </td>
              <td v-if="ObservacionSolicitudRepresentanteLegal != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  @click.prevent="AprobarSolicitudRepresentante()"
                  class="texto-tabla-obs"
                >
                  Aprobar
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Aprobar
                </label>
              </td>
            </tr>
            <tr v-if="tipoPersona == 1" class="mt-3">
              <td class="texto-tabla">Cuestionario de preanálisis</td>
              <td>
                <label
                  class="texto-tabla-obs text-left"
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  @click.prevent="cargarCuestionario()"
                >
                  Ver/editar cuestionario
                </label>
                <label
                  v-else
                  class="texto-tabla-obs text-left"
                  @click.prevent="cargarCuestionario()"
                >
                  Ver cuestionario
                </label>
              </td>
              <td>-</td>
              <td v-if="ObservacionCuestionarioPreanalisis != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  class="texto-tabla-obs"
                  @click.prevent="ObservacionCuestionario(true)"
                >
                  Ver Observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Ver Observación
                </label>
              </td>
              <td v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="ObservacionCuestionario(false)"
                >
                  + Agregar una observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  + Agregar una observación
                </label>
              </td>
              <td v-if="ObservacionCuestionarioPreanalisis != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  @click.prevent="AprobarCuestionario()"
                >
                  Aprobar
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Aprobar
                </label>
              </td>
            </tr>

            <tr
              v-for="(archivo, index) in ArchivosExpedienteAuxiliar"
              :key="archivo.archivoId"
              class="mt-3"
            >
              <td class="texto-tabla">
                {{
                  archivo.tipoDocumentoStr.charAt(0).toUpperCase() +
                    archivo.tipoDocumentoStr.slice(1)
                }}
              </td>
              <td
                class="p-8"
                v-if="tipoUsuario == 4 || tipoUsuario || tipoUsuario == 10"
              >
                <input
                  class="d-none"
                  type="file"
                  ref="inputArchivo"
                  @change="almacenarArchivo($event, index)"
                />
                <InputDocumentos
                  ajusteMarginBoton="margin-top: -1px"
                  :Documento="archivo.documento"
                  :NombreArchivo="archivo.nombreOriginal"
                  :esExtranjero="false"
                  @click.native="ActivaInputArchivo(index)"
                  :desactivar="desactivarInputArchivo"
                ></InputDocumentos>
              </td>
              <td v-else class="p-8">
                <label class="texto-tabla-obs text-left">
                  {{ archivo.nombreOriginal }}
                </label>
              </td>
              <td class="tabla-preautorizacion__td-acciones p-0">
                <i
                  v-if="archivo.extension == '.PDF'"
                  data-bs-toggle="modal"
                  data-bs-target="#modalPdf"
                  v-on:click="VerArchivo(archivo.archivoId)"
                  class="fa fa-eye iconoVer-png"
                ></i>
                <i
                  v-else
                  v-on:click="AvisoFormato()"
                  class="fa fa-eye iconoVer-png"
                ></i>
                <i
                  v-on:click="descargarArchivo(archivo.archivoId)"
                  class="fa fa-download iconoArchivo-png"
                ></i>
                <i
                  v-if="
                    (tipoUsuario == 4 ||
                      tipoUsuario == 8 ||
                      tipoUsuario == 10) &&
                      archivo.documento != 20
                  "
                  @click="eliminarArchivo(archivo.archivoId)"
                  class="fa fa-trash iconoBorrar-png"
                ></i>
              </td>
              <td v-if="archivo.esAprobado == false">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  Ver observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Ver observación
                </label>
              </td>
              <td v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  + Agregar una observación
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  + Agregar una observación
                </label>
              </td>
              <td v-if="archivo.esAprobado == false">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  @click.prevent="AprobarArchivo(archivo.archivoId, 0)"
                >
                  Aprobar
                </label>
                <label v-else class="texto-tabla-obs texto-deshabilitado">
                  Aprobar
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--ESTO SOLO SE MUESTRA EN MOVIL-->
      <div class="listado-documentos-movil">
        <!--SOLICITUD DE INSCRIPCIÓN-->
        <div class="row col-lg-12">
          <strong
            class="titulo-seccion documento-movil"
            style="margin-right: 10px"
          >
            Solicitud de inscripción
          </strong>
          <div class="row col-12" style="margin-top: -10px">
            <div class="col-10" style="text-align: initial">
              <div v-if="ObservacionSolicitudPersonaFisica != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  @click.prevent="ObservacionSolicitud()"
                  class="texto-tabla-obs"
                  data-bs-target="#modalObservacion"
                  data-bs-toggle="modal"
                >
                  Ver observación
                </label>
                <label
                  v-else
                  class="texto-tabla-obs texto-deshabilitado"
                  style="display: block"
                >
                  Ver observación
                </label>
              </div>
              <div v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  data-bs-target="#modalObservacion"
                  data-bs-toggle="modal"
                  @click.prevent="ObservacionSolicitud()"
                >
                  + Agregar una observación
                </label>
                <label
                  v-else
                  class="texto-tabla-obs texto-deshabilitado"
                  style="display: block"
                >
                  + Agregar una observación
                </label>
              </div>
              <div v-if="ObservacionSolicitudPersonaFisica != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  @click.prevent="
                    AprobarSolicitud(
                      ObservacionSolicitudPersonaFisica.entidadId,
                      1,
                    )
                  "
                >
                  Aprobar
                </label>
                <label
                  v-else
                  class="texto-tabla-obs texto-deshabilitado"
                  style="display: block"
                >
                  Aprobar
                </label>
              </div>
            </div>
            <div class="col-2">
              <i
                v-if="tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10"
                class="fas fa-pen icono-movil"
                v-on:click.prevent="cargarSolicitud()"
              ></i>
              <i
                v-else
                class="far fa-eye icono-movil"
                v-on:click.prevent="cargarSolicitud()"
              ></i>
            </div>
          </div>
        </div>
        <!--SOLICITUD DE INSCRIPCIÓN REPRESENTANTE LEGAL-->
        <div class="row col-lg-12" v-if="tipoPersona == 1">
          <strong
            class="titulo-seccion documento-movil"
            style="margin-right: 10px"
          >
            Solicitud de inscripción (Representante legal)
          </strong>
          <div class="row col-12" style="margin-top: -10px">
            <div class="col-10" style="text-align: initial">
              <div v-if="ObservacionSolicitudRepresentanteLegal != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  @click.prevent="ObservacionSolicitudRepresentante(true)"
                  data-bs-target="#modalObservacion"
                  data-bs-toggle="modal"
                >
                  Ver observación
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  Ver observación
                </label>
              </div>
              <div v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="ObservacionSolicitudRepresentante(false)"
                >
                  + Agregar una observación
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  + Agregar una observación
                </label>
              </div>
              <div v-if="ObservacionSolicitudRepresentanteLegal != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  @click.prevent="AprobarSolicitudRepresentante()"
                ></label>
                <label
                  v-else
                  tyle="display:block;"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  Aprobar
                </label>
              </div>
            </div>
            <div class="col-2">
              <i
                v-if="tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10"
                class="fas fa-pen icono-movil"
                v-on:click.prevent="cargarSolicitudRepresentante()"
              ></i>
              <i
                v-else
                class="far fa-eye icono-movil"
                v-on:click.prevent="cargarSolicitudRepresentante()"
              ></i>
            </div>
          </div>
        </div>
        <!--CUESTIONARIO PRE ANÁLISIS-->
        <div class="row col-lg-12" v-if="tipoPersona == 1">
          <strong
            class="titulo-seccion documento-movil"
            style="margin-right: 10px"
          >
            Cuestionario de preanálisis
          </strong>
          <div class="row col-12" style="margin-top: -10px">
            <div class="col-10" style="text-align: initial">
              <div v-if="ObservacionCuestionarioPreanalisis != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="ObservacionCuestionario(true)"
                >
                  Ver observación
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  Ver observación
                </label>
              </div>
              <div v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="ObservacionCuestionario(false)"
                >
                  + Agregar una observación
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  + Agregar una observación
                </label>
              </div>
              <div v-if="ObservacionCuestionarioPreanalisis != null">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  @click.prevent="AprobarCuestionario()"
                >
                  Aprobar
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  Aprobar
                </label>
              </div>
            </div>
            <div class="col-2">
              <i
                v-if="tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10"
                class="fas fa-pen icono-movil"
                @click.prevent="cargarCuestionario()"
              ></i>
              <i
                v-else
                class="far fa-eye icono-movil"
                @click.prevent="cargarCuestionario()"
              ></i>
            </div>
          </div>
        </div>
        <!--DOCUMENTOS-->
        <div
          class="row col-lg-12"
          v-for="archivo in ArchivosExpediente"
          :key="archivo.archivoId"
        >
          <strong
            class="titulo-seccion documento-movil"
            style="margin-right: 10px"
          >
            {{
              archivo.tipoDocumentoStr.charAt(0).toUpperCase() +
                archivo.tipoDocumentoStr.slice(1) +
                "(" +
                archivo.documentoStr +
                ")"
            }}
          </strong>
          <div class="row col-12" style="margin-top: -10px">
            <div class="col-10" style="text-align: initial">
              <label class="texto-tabla-obs">
                {{ archivo.nombreOriginal }}
              </label>
              <div v-if="archivo.esAprobado == false">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  class="texto-tabla-obs"
                  style="display: block"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  Ver observación
                </label>
                <label
                  v-else
                  class="texto-tabla-obs texto-deshabilitado"
                  style="display: block"
                >
                  Ver observación
                </label>
              </div>
              <div v-else>
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  data-bs-toggle="modal"
                  data-bs-target="#modalObservacion"
                  @click.prevent="RechazarArchivo(archivo.archivoId)"
                >
                  + Agregar una observación
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  + Agregar una observación
                </label>
              </div>
              <div v-if="archivo.esAprobado == false">
                <label
                  v-if="
                    tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10
                  "
                  style="display: block"
                  class="texto-tabla-obs"
                  @click.prevent="AprobarArchivo(archivo.archivoId, 0)"
                >
                  Aprobar
                </label>
                <label
                  v-else
                  style="display: block"
                  class="texto-tabla-obs texto-deshabilitado"
                >
                  Aprobar
                </label>
              </div>
            </div>
            <div class="col-2">
              <i
                v-on:click="descargarArchivo(archivo.archivoId)"
                class="fa fa-download iconoArchivo-png"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row row-cols-lg-12"
        style="justify-content: flex-end; margin-bottom: 10px"
      >
        <strong
          class="etiqueta-nuevo-documento etiqueta-descargar-todos mt-3 w-auto"
          v-on:click="descargarTodosLosArchivosZip()"
          >Descargar todos los archivos</strong
        >
      </div>
      <div
        v-if="
          (tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10) &&
            tipoUsuario != 1
        "
        class="row row-cols-lg-12 mt-6"
      >
        <div class="col-lg-7" style="text-align: left">
          <label v-if="tipoUsuario != 5" class="mb-1 fw-bold">
            Observaciones del administrador o gerente:
          </label>
          <textarea
            v-if="tipoUsuario == 4 || tipoUsuario == 5 || tipoUsuario == 8"
            v-model="estatusObservacion"
            class="form-control campo-basico"
          >
          </textarea>
          <textarea
            v-else
            class="form-control campo-basico"
            rows="2"
            disabled
            v-model="estatusObservacion"
          >
          </textarea>
          <button
            style="height: 50px"
            class="btn boton-primario w-50 boton-preautorizacion mt-3"
            @click="GuardarEstatusObservacion()"
          >
            Enviar comentarios
          </button>
        </div>
        <div class="col-lg-5 mt-4 mt-lg-0">
          <div class="panel-consultas-externas">
            <div class="panel-consultas-externas__header">
              <span>CONSULTAS EXTERNAS</span>
              <i class="fas fa-external-link-alt"></i>
            </div>
            <div
              v-if="procesandoConsultaBuro"
              style="text-align: center; width: 100%;"
            >
              <v-progress-circular
                indeterminate
                size="25"
                color="primary"
              ></v-progress-circular>
            </div>
            <button
              v-if="false && tipoPersona == 0"
              class="btn w-100 boton-motor-decision"
              :disabled="procesandoMotorDecision"
              @click.prevent="MotorDecision()"
            >
              <v-progress-circular
                v-if="procesandoMotorDecision"
                indeterminate
                size="20"
                color="white"
              ></v-progress-circular>
              <template v-else>
                <span>Motor de Decisión</span>
                <i class="fas fa-external-link-alt"></i>
              </template>
            </button>
            <button
              v-if="mostrarBotonBuro"
              class="btn w-100 boton-consulta-buro"
              @click.prevent="consultarYRegistrarBuro(ProspectoId)"
            >
              <span>Consulta de Buró</span>
              <i class="fas fa-external-link-alt"></i>
            </button>
            <button
              v-else
              disabled
              class="btn w-100 boton-consulta-buro boton-consulta-buro--bloqueado"
            >
              <i class="fas fa-lock"></i>
              <span>Consulta de Buró</span>
              <i class="fas fa-external-link-alt"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="row row-cols-lg-12 mt-6"
        v-if="tipoUsuario == 4 || tipoUsuario == 8 || tipoUsuario == 10"
      >
        <div class="col-lg-4">
          <button
            v-if="rechazando"
            disabled
            style="height: 50px"
            class="btn boton-transparente w-100 boton-preautorizacion"
          >
            <v-progress-circular
              indeterminate
              size="25"
              color="#b8725a"
            ></v-progress-circular>
          </button>
          <button
            v-else
            style="height: 50px"
            class="btn boton-transparente w-100 boton-preautorizacion"
            v-on:click="rechazarYEnviarACorreccion"
          >
            Rechazar y enviar a corrección
          </button>
        </div>
        <div class="col-lg-4">
          <button
            style="height: 50px"
            class="
              btn
              boton-transparente
              w-100
              boton-preautorizacion boton-preautorizacion-ajuste
            "
            data-bs-toggle="modal"
            data-bs-target="#modalCancelarProspecto"
          >
            Cancelar prospecto
            <v-progress-circular
              indeterminate
              size="30"
              color="white"
              v-if="loadingCancelarProspecto"
            ></v-progress-circular>
          </button>
        </div>
        <div class="col-lg-4">
          <button
            v-if="loadingAprobarEnviarPago"
            disabled
            style="height: 50px"
            class="
              btn
              boton-primario
              w-100
              boton-preautorizacion boton-preautorizacion-ajuste
            "
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="white"
            ></v-progress-circular>
          </button>
          <button
            class="
              btn
              boton-primario
              w-100
              boton-preautorizacion boton-preautorizacion-ajuste
            "
            style="height: 50px"
            v-else-if="tipoPersona != 0 && tipoPersona != 1 && tipoPersona != 2"
            v-on:click="aprobarYEnviarAPago"
          >
            Aprobar
          </button>
          <button
            v-else
            style="height: 50px"
            class="
              btn
              boton-primario
              w-100
              boton-preautorizacion boton-preautorizacion-ajuste
            "
            v-on:click="aprobarYEnviarAPago"
          >
            Aprobar y enviar a pago
          </button>
        </div>
      </div>
      <!-- model cancelación prospecto -->
      <div
        class="modal fade"
        id="modalCancelarProspecto"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Ingresa el motivo de la cancelación</h5>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <DropDown
                placeholder="Seleccione un motivo de cancelación *"
                :arreglo="this.motivosCancelacion"
                llave="observacionCnaId"
                valor="motivoCancelacionId"
                texto="motivo"
                v-model="motivoId"
                :requerido="true"
              ></DropDown>
              <br />
              <label class="float-left"
                >Escriba una observación (opcional)</label
              >
              <textarea
                class="form-control"
                v-model="observacionCancelacion"
                rows="2"
              ></textarea>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn boton-negro"
                data-bs-dismiss="modal"
                ref="botoncerrarCancelacion"
              >
                Cancelar
              </button>
              <button
                type="button"
                @click.prevent="CancelarProspecto"
                class="btn boton-primario"
              >
                Terminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
//Componentes
import DropDown from "../../Prospecto/components/DropDown.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import ModalPdf from "../components/ModalPdf.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
//Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

import {
  obtenerDatosProspectoBuroCredito,
  enviarDatosProspectoBuroCredito,
  motorDecision,
  getSession,
} from "@/Aplicaciones/Masters/apiConnection/api_client";

const rutaVerificarAutorizacionBuro =
  "/api/Master/PreAutorizacion/VerificarAutorizacion";
const rutaCargarArchivosExpedienteProspecto =
  "/api/Master/PreAutorizacion/CargarArchivosExpedienteProspecto";
const rutaGuardarObservacionArchivo =
  "/api/Master/PreAutorizacion/GuardarObservacionArchivo";
const rutaConsultarObservacionArchivo =
  "/api/Master/PreAutorizacion/ConsultarObservacionArchivo";
const rutaEliminarObservacion =
  "/api/Master/PreAutorizacion/EliminarObservacion";
const rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";
const rutaDescargarArchivoZip = "/api/Master/Archivo/DescargarArchivosZip";
const rutaEliminarArchivo = "/api/Master/Archivo/EliminarArchivo";
const rutaVerArchivo = "/api/Master/Archivo/VerArchivo";

const rutaListarMotivosCancelacionPreAutorizacion =
  "/api/Master/Cancelacion/ListarMotivosCancelacionPreAutorizacion";

const rutaRechazarPreAutorizacionYEnviarACorreccion =
  "/api/Master/PreAutorizacion/RechazarPreAutorizacionYEnviarACorreccion";

const rutaAprobarYEnviarAPago =
  "/api/Master/PreAutorizacion/AprobarPreAutorizacionYEnviarAPago";
const rutaConsultarEmbajador =
  "/api/Master/Prospecto/ObtenerProspectoEmbajador";
const rutaConsultarProspectoRepresentante =
  "/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal";
const rutaCancelarProspecto = "/api/Master/Prospecto/CancelarProspecto/";
const rutaSolicitudTieneObservacion =
  "/api/Master/IntegracionExpediente/ConsultarObservacionSolicitud";
const rutaObtenerMontoPropiedad =
  "/api/Master/Prospecto/ConsultarMontoPropiedad";
const rutaSustituirArchivoProspecto =
  "/api/Master/PreAutorizacion/SustituirArchivoProspecto";
const rutaConsultaEstatus = "/api/Master/Prospecto/ObtenerObservacionEstatus";
const rutaGuardarEstatus = "/api/Master/Prospecto/GuardarObservacionEstatus";

const rutaEnviarACore = "/api/Master/PreAutorizacion/EnviarACore";
const rutaCompletarProceso = "/api/Master/PreAutorizacion/CompletarProceso";
const rutaObtenerPermiso =
  "/api/Master/PreAutorizacion/ConsultaPermisoPreAutorizacion";
const rutaCreaSolicitudInscripcion =
  "/api/Master/CajaDorada/CrearSolicitudInscripcion";
const rutaCreaSolicitudInscripcionMoral =
  "/api/Master/CajaDorada/CrearSolicitudInscripcionMoral";

export default {
  name: "PreAutorizacion",
  mixins: [mixinSolicitudInscripcion],
  components: {
    DropDown,
    TituloSeccion,
    ModalPdf,
    InputDocumentos,
  },
  async mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = await this.ObtenerTipoPersona(this.ProspectoId);
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.usuarioId = this.$store.getters.usuarioId;

    let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;
    this.etapaProspecto = datos.etapaId;
    this.TipoInmueble = datos.tipoInmuebleNombre;
    this.UsoInmueble = datos.usoInmuebleNombre;
    this.TipoUbicacion = datos.tipoUbicacionNombre;
    this.Estado = datos.estadoNombre;
    this.FechaAltaProspecto = datos.fechaCreacion;

    this.FechaPreautorizacion = (
      await this.ObtenerTransicionProspecto(this.ProspectoId, 5)
    ).data.data;
    this.FechaGeneracionPago = (
      await this.ObtenerTransicionProspecto(this.ProspectoId, 7)
    ).data.data;

    this.tipoCliente =
      this.tipoPersona == 0
        ? "TITULAR NACIONAL."
        : this.tipoPersona == 1
        ? "TITULAR MORAL."
        : this.tipoPersona == 2
        ? "TITULAR EXTRANJERO."
        : this.tipoPersona == 3
        ? "REPRESENTANTE LEGAL"
        : this.tipoPersona == 4
        ? "COTITULAR"
        : this.tipoPersona == 5
        ? "CO-OWNER"
        : this.tipoPersona == 6
        ? "OBLIGADO SOLIDARIO"
        : "JOINT LIABILITY";
    this.nombreCliente =
      this.tipoPersona == 1
        ? datos.nombres +
          " - " +
          datos.apellidoPaterno +
          " " +
          datos.apellidoMaterno
        : this.tipoPersona == 2 ||
          this.tipoPersona == 5 ||
          this.tipoPersona == 7
        ? datos.nombres +
          " " +
          datos.apellidoMaterno +
          " " +
          datos.apellidoPaterno
        : datos.nombres +
          " " +
          datos.apellidoPaterno +
          " " +
          datos.apellidoMaterno;

    await this.ObtenerDatosEmbajador(this.ProspectoId);

    if (this.etapaId > 5 && this.tipoUsuario == 3) {
      this.$router.push({
        name: "SeguimientoProspecto",
      });
    } else if (this.etapaId > 5 && this.tipoUsuario != 3) {
      this.$router.push({
        name: "AdministracionDeProspectos",
      });
    }

    this.ConsultarMontoPropiedad();
    this.ConsultarSolicitudes(this.ProspectoId, false);
    this.SolicitudTieneObservacion(this.ProspectoId, 1);
    if (this.tipoPersona == 1) {
      this.ConsultarProspectoRepresentanteLegal();
      this.ConsultarCuestionario(this.ProspectoId);
    }
    this.listarMotivosCancelacion();
    this.ConsultarEstatus();
    await this.consultarAutorizacionBuro(this.ProspectoId);
        await this.validarBotonBuro();

    //Generacion de Solicitud de inscripcion
    let idFiguras = (await this.ObtenerFiguraId(this.ProspectoId, 4)).data.data;
    idFiguras.forEach((x) => {
      if (x.tipoPersona == 4 || x.tipoPersona == 5)
        this.Cotitulares.push(x.prospectoId);
    });

    if (this.tipoPersona == 1) {
      await this.ConsultarProspectoRepresentanteLegal();
    }
    if (this.tipoPersona == 1) {
      await this.ConsultarSolicitudes(this.ProspectoId, true);
      this.solicitudExistenteId = this.SolicitudRepresentanteId;
    } else {
      await this.ConsultarSolicitudes(this.ProspectoId, false);
      this.solicitudExistenteId = this.SolicitudId;
    }

    if (this.solicitudExistenteId != 0) {
      await this.ConsultarSolicitudGeneral(
        this.ProspectoRepresentanteLegalId != 0
          ? this.ProspectoRepresentanteLegalId
          : this.ProspectoId,
      );
    }
    await this.CreaSolicitud();

    this.cargarArchivosExpedienteProspecto();
  },
  data() {
    return {
      tipoCliente: null,
      nombreCliente: null,
      ProspectoId: null,
      etapaProspecto: null,
      FechaAltaProspecto: "Sin Fecha",
      FechaPreautorizacion: "Sin Fecha",
      FechaGeneracionPago: "Sin Fecha",
      TipoInmueble: "",
      UsoInmueble: "",
      TipoUbicacion: "",
      Estado: "",
      datosEmbajador: {
        nombre: null,
        correo: null,
        telefono: null,
        sucursal: null,
        gerencia: null,
        perfil: null,
      },
      estatusObservacion: "Sin observaciones actuales.",
      montoPropiedad: null,
      ArchivosExpediente: [],
      ArchivosExpedienteAuxiliar: [],
      archivorechazado: {
        id: null,
        rechazado: false,
      },
      Observacion: {
        entidadId: null,
        entidadObservacion: null,
        motivoObservacion: "",
        fechaObservacion: null,
        feechaCorrecion: null,
        activo: false,
      },
      ObservacionSolicitudPersonaFisica: null,
      ObservacionSolicitudRepresentanteLegal: null,
      ObservacionCuestionarioPreanalisis: null,
      ObservacionArchivo: null,
      motivosCancelacion: [],
      observacionCancelacion: null,
      motivoId: null,
      tipoPersona: 0,
      tipoUsuario: null,
      usuarioId: null,
      ProspectoRepresentanteLegalId: null,
      SolicitudId: null,
      SolicitudRepresentanteId: null,
      CuestionarioPersonaMoralId: null,
      solicitudTieneObservacion: false,
      solicitudRepresentanteTieneObservacion: false,
      cuestionarioTieneObservacion: false,
      urlPdf: null,
      //loadings:
      enviandoObservacion: false,
      rechazando: false,
      loadingCancelarProspecto: false,
      loadingAprobarEnviarPago: false,
      desactivarInputArchivo: false,
      preautorizar: true,
      FigurasAdicionales: [],
      Cotitulares: [],
      infoBuroConsultada: false,
      procesandoConsultaBuro: false,
      procesandoMotorDecision: false,
        mostrarBotonBuro: false,
    };
  },
  methods: {
    async CreaSolicitud() {
      try {
        if (this.tipoPersona == 1) {
          await this.CreaSolicitudInscripcionMoral(this.ProspectoId);
          //Aqui se crea solicitud de moral
          await this.CreaSolicitudInscripcionRepresentanteLegal(
            this.ProspectoRepresentanteLegalId,
          );
          //await this.ConsultaNumerosContrato(this.ProspectoId);
          await this.CreaAnexoSolicitudPersonaMoral(this.ProspectoId);
        } else if (this.tipoPersona == 0 || this.tipoPersona == 2) {
          await this.CreaSolicitudInscripcion();
        } else if (this.tipoPersona == 4 || this.tipoPersona == 5) {
          await this.CreaSolicitudInscripcionCotitular(this.ProspectoId);
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcion() {
      const paqueteDeDatos = {
        params: {
          prospectoId: this.ProspectoId,
          tipoDocumento: 29,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcion, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcionCotitular(cotitularId) {
      const paqueteDeDatos = {
        params: {
          prospectoId: cotitularId,
          tipoDocumento: 31,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcion, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcionMoral(ProspectoMoralId) {
      const paqueteDeDatos = {
        params: {
          prospectoId: ProspectoMoralId,
          tipoDocumento: 33,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcionMoral, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcionRepresentanteLegal(
      ProspectoRepresentanteLegalId,
    ) {
      const paqueteDeDatos = {
        params: {
          prospectoId: ProspectoRepresentanteLegalId,
          tipoDocumento: 32,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcion, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    DarFormatoMoneda(monto) {
      return servicios.DarFormatoMoneda(monto);
    },
    ConsultarEstatus() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaConsultaEstatus, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data == null)
              this.estatusObservacion = "Sin observaciones actuales.";
            else this.estatusObservacion = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async consultarAutorizacionBuro(prospectoId) {
      try {
        this.procesandoConsultaBuro = true;
        const resp = await axios.get(rutaVerificarAutorizacionBuro, {
          params: { prospectoId: prospectoId },
        });
        if (resp.data.estado === 0) {
          const { tieneDocumento } = resp.data.data;
          this.infoBuroConsultada = tieneDocumento;
        }
        this.procesandoConsultaBuro = false;
      } catch (e) {
        this.procesandoConsultaBuro = false;
        console.log(e);
        this.AlertaEmbajadores(
          "No pudimos completar la consulta de buró de crédito. Intenta nuevamente.",
          true,
        );
      }
    },
    async validarBotonBuro() {
      try {
        // 1. Verificar si es nacional (tipoPersona == 0)
        const esNacional = this.tipoPersona === 0;
        
        // 2. Verificar autorizacion Incode (sesion COMPLETA)
        let tieneIncode = false;
        try {
          const session = await getSession(this.ProspectoId);
          if (session) {
            tieneIncode = session.finishStatus === 'COMPLETE';
          }
        } catch (e) {
          console.log('Error checking Incode session:', e);
          tieneIncode = false;
        }
        
        // 3. Verificar autorizacion Buró (usando endpoint existente)
        let tieneBuro = false;
        let tieneDocumentoBuro = false;
        try {
          const resp = await axios.get(rutaVerificarAutorizacionBuro, {
            params: { prospectoId: this.ProspectoId },
          });
          if (resp.data.estado === 0) {
            const { tieneAutorizacion, tieneDocumento } = resp.data.data;
            tieneBuro = tieneAutorizacion;
            tieneDocumentoBuro = tieneDocumento;
          }
        } catch (e) {
          console.log('Error checking Buró authorization:', e);
          tieneBuro = false;
          tieneDocumentoBuro = false;
        }

        // El botón no debe mostrarse si ya existe el documento de buró consultado
        this.mostrarBotonBuro =
          esNacional && tieneIncode && tieneBuro && !tieneDocumentoBuro;
      } catch (e) {
        console.log(e);
        this.mostrarBotonBuro = false;
      }
    },
    async procesarDatosBuroCredito() {
      try {
        this.procesandoConsultaBuro = true;
        const { data } = await obtenerDatosProspectoBuroCredito(
          this.ProspectoId,
        );
        if (data) {
          await enviarDatosProspectoBuroCredito(this.ProspectoId);
          this.procesandoConsultaBuro = false;
          // Documento generado exitosamente: bloquear el botón
          this.mostrarBotonBuro = false;
          this.AlertaEmbajadores(
            "La consulta de buró de crédito se realizó correctamente.",
            true,
          );
        } else {
          this.procesandoConsultaBuro = false;
          this.AlertaEmbajadores(
            "No logramos encontrar los datos personales del prospecto, por favor intentalo nuevamente.",
            true,
          );
        }
      } catch (e) {
        console.log(e);
        this.procesandoConsultaBuro = false;
        this.AlertaEmbajadores(
          "No logramos procesar los datos de buró de crédito, por favor intentalo nuevamente.",
          true,
        );
      }
    },
    async consultarYRegistrarBuro(prospectoId) {
      await this.procesarDatosBuroCredito();
      await this.consultarAutorizacionBuro(prospectoId);
      this.cargarArchivosExpedienteProspecto();
    },

    async MotorDecision() {
      const ventana = window.open("", "_blank", "width=1200,height=800,resizable=yes,scrollbars=yes");
      try {
        this.procesandoMotorDecision = true;
        const { data } = await motorDecision(this.ProspectoId, this.usuarioId);
        this.procesandoMotorDecision = false;
        console.log(data);
        if (data && data.url) {
          if (ventana) {
            ventana.location.href = data.url;
          } else {
            this.AlertaEmbajadores(data.url, false);
          }
          this.AlertaEmbajadores(
            "Se generó correctamente la consulta en el Motor de Decisión.",
            false,
          );
        } else {
          if (ventana) ventana.close();
          this.AlertaEmbajadores(
            data && data.mensaje
              ? data.mensaje
              : "El Motor de Decision no devolvió una URL válida.",
            true,
          );
        }
      } catch (e) {
        console.log(e);
        this.procesandoMotorDecision = false;
        if (ventana) ventana.close();
        this.AlertaEmbajadores(
          "No logramos contactar al Motor de Decision, por favor intentalo nuevamente.",
          true,
        );
      }
    },
    GuardarEstatusObservacion() {
      axios
        .post(
          rutaGuardarEstatus +
            "/?prospectoId=" +
            this.ProspectoId +
            "&observacionEstatus=" +
            this.estatusObservacion +
            "&tipoUsuario=" +
            this.tipoUsuario,
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(
              "Se guardó correctamente la observación y será visible para el pre autorizador",
              true,
            );
            this.ConsultarEstatus();
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    //Archivos
    ActivaInputArchivo(index) {
      this.$refs.inputArchivo[index].click();
    },
    almacenarArchivo(event, index) {
      this.ArchivosExpedienteAuxiliar[index].archivo = event.target.files[0];
      this.subirArchivo(index);
    },
    subirArchivo(index) {
      if (this.ProspectoId != null) {
        if (this.ArchivosExpedienteAuxiliar[index].archivoId != null) {
          if (this.ArchivosExpedienteAuxiliar[index].archivo === null) {
            this.AlertaEmbajadores("No se eligió ningun archivo.", true);
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.ArchivosExpedienteAuxiliar[index].archivo,
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.ArchivosExpedienteAuxiliar[index].archivo,
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.ArchivosExpedienteAuxiliar[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.ArchivosExpedienteAuxiliar[index].archivoId,
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.ArchivosExpedienteAuxiliar[index].archivo,
        );
        axios
          .post(rutaSustituirArchivoProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarArchivosExpedienteProspecto();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    eliminarArchivo(archivoId) {
      this.$fire({
        title: "Eliminar archivo",
        html:
          "<br>Estás por eliminar este archivo<br>" + "¿Deseas continuar?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
          var paqueteDeDatos = new FormData();
          paqueteDeDatos.append("archivoId", archivoId);
          return axios
            .post(rutaEliminarArchivo, paqueteDeDatos)
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.cargarArchivosExpedienteProspecto();
                this.AlertaEmbajadores(resp.data.mensaje, true);
              } else if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje, true);
              }
            })
            .catch((e) => {
              this.ManejarExcepcion(e);
            });
        }
      });
    },
    ConsultarMontoPropiedad() {
      const parametroProspectoId = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaObtenerMontoPropiedad, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.montoPropiedad = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    SolicitudTieneObservacion(prospecto, entidad) {
      const parametroProspectoId = {
        params: {
          prospectoId: prospecto,
          entidad: entidad,
        },
      };
      axios
        .get(rutaSolicitudTieneObservacion, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data != null) {
              this.ObservacionSolicitudPersonaFisica = resp.data.data;
            } else {
              this.ObservacionSolicitudPersonaFisica = null;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarSolicitudRepresentante(prospectoId) {
      const prospecto = {
        params: {
          prospectoId: prospectoId,
        },
      };
      axios
        .get(
          "/api/Master/IntegracionExpediente/ConsultarSolicitudes",
          prospecto,
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.SolicitudRepresentanteId = resp.data.data;
            this.SolicitudRepresentanteTieneObservacion(
              this.ProspectoRepresentanteLegalId,
              2,
            );
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarProspectoRepresentanteLegal() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaConsultarProspectoRepresentante, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ProspectoRepresentanteLegalId = resp.data.data;
            this.ConsultarSolicitudRepresentante(
              this.ProspectoRepresentanteLegalId,
            );
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ObtenerPermiso() {
      const usuario = {
        params: {
          UsuarioId: this.usuarioId,
        },
      };
      axios
        .get(rutaObtenerPermiso, usuario)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.preautorizar = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ObtenerDatosEmbajador() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaConsultarEmbajador, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.datosEmbajador = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    cargarCuestionario() {
      this.$store.commit("setSolicitudMoral", this.SolicitudId);
      this.$router.push({
        name: "CuestionarioPreAnalisisPersonaMoral",
      });
    },
    cargarSolicitudRepresentante() {
      this.$store.commit(
        "setSolicitudRepresentante",
        this.SolicitudRepresentanteId,
      );
      this.$store.commit(
        "setProspectoRepresentanteLegal",
        this.ProspectoRepresentanteLegalId,
      );
      this.$router.push({
        name: "FormularioSolicitudInscripcion",
        params: {
          esRepresentante: true,
        },
      });
    },
    cargarSolicitud() {
      switch (this.tipoPersona) {
        case 1:
          this.$store.commit("setSolicitudMoral", this.SolicitudId);
          this.$router.push({
            name: "FormularioSolicitudInscripcionMoral",
          });
          break;
        case 2:
          this.$store.commit("setSolicitudExtranjera", this.SolicitudId);
          this.$router.push({
            name: "FormularioSolicitudInscripcionex",
          });
          break;
        case 0:
          this.$store.commit("setSolicitudFisica", this.SolicitudId);
          this.$router.push({
            name: "FormularioSolicitudInscripcion",
          });
          break;
        case 4:
        case 6:
          this.$store.commit("setSolicitudFisica", this.SolicitudId);
          this.$router.push({
            name: "DatosPersonalesFiguraAdicional",
          });
          break;
        case 5:
        case 7:
          this.$store.commit("setSolicitudFisica", this.SolicitudId);
          this.$router.push({
            name: "DatosPersonalesFiguraAdicionalex",
          });
          break;
      }
    },
    descargarTodosLosArchivosZip() {
      //No dejar espacios en el nombre
      var nombreZip = "DocumentosPreAutorizacion";
      var archivosPorDescargar = this.ArchivosExpediente.slice();
      var archivosIdJson;
      var archivosIdArray = new Array();

      archivosPorDescargar.forEach(function(value) {
        archivosIdArray.push(value.archivoId);
      });

      archivosIdJson = JSON.stringify(archivosIdArray);
      if (archivosPorDescargar.length > 0) {
        window.location.href =
          rutaDescargarArchivoZip +
          "?archivosIdJson=" +
          archivosIdJson +
          "&nombreZip=" +
          nombreZip;
      } else {
        this.AlertaEmbajadores("No hay contratos para descargar.", true);
      }
    },
    descargarTodosLosArchivos() {
      var archivosPorDescargar = this.ArchivosExpediente;
      archivosPorDescargar.forEach(function(value, index) {
        setTimeout(() => {
          window.location.href =
            rutaDescargarArchivo + "?archivoId=" + value.archivoId;
        }, index * 1000);
      });
    },

    cargarArchivosExpedienteProspecto() {
      this.ArchivosExpedienteAuxiliar = [];

      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };

      axios
        .get(rutaCargarArchivosExpedienteProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloArchivos = resp.data.data;
            this.ArchivosExpediente = arregloArchivos;
            for (var a of arregloArchivos) {
              let aux = {
                archivoId: a.archivoId,
                nombreOriginal: a.nombreOriginal,
                documento: a.documento,
                tipoDocumentoStr: a.tipoDocumentoStr,
                esAprobado: a.esAprobado,
                archivo: null,
                extension: a.extension,
              };
              this.ArchivosExpedienteAuxiliar.push(aux);
            }
            //this.ArchivosExpediente = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    listarMotivosCancelacion() {
      axios
        .get(rutaListarMotivosCancelacionPreAutorizacion)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.motivosCancelacion = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    rechazarYEnviarACorreccion() {
      this.rechazando = true;
      axios
        .post(
          rutaRechazarPreAutorizacionYEnviarACorreccion +
            "?prospectoId=" +
            this.ProspectoId,
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.rechazando = false;
            this.AlertaEmbajadores(
              "El expediente ha sido regresado a corrección",
              true,
            );
            this.$router.push({
              name: "AdministracionDeProspectos",
            });
          } else if (resp.data.estado === 1) {
            this.rechazando = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.rechazando = false;
          this.ManejarExcepcion(e);
        });
    },
    aprobarYEnviarHojaPrueba() {
      if (this.ArchivosExpedienteAuxiliar.length < 3) {
        this.loadingAprobarEnviarPago = false;
        this.AlertaEmbajadores(
          "No se puede aprobar al prospecto debido a la falta de archivos para el expediente.",
          true,
        );
        return;
      } else {
        this.$router.push({
          name: "HojaPrueba",
        });
      }
    },
    CompletarProceso() {
      axios
        .post(
          rutaCompletarProceso +
            "/?prospectoId=" +
            this.ProspectoId +
            "&solicitudId=" +
            this.SolicitudId +
            "&aplicacionId=0",
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.$router.push({
              name: "AdministracionDeProspectos",
            });
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarACore() {
      axios
        .post(
          rutaEnviarACore +
            "/?prospectoId=" +
            this.ProspectoId +
            "&solicitudId=" +
            this.SolicitudId +
            "&aplicacionId=0",
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
            this.$router.push({
              name: "AdministracionDeProspectos",
            });
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    aprobarYEnviarAPago() {
      if (this.ArchivosExpedienteAuxiliar.length < 3) {
        this.loadingAprobarEnviarPago = false;
        this.AlertaEmbajadores(
          "No se puede aprobar al prospecto debido a la falta de archivos para el expediente.",
          true,
        );
        return;
      }
      this.loadingAprobarEnviarPago = true;
      axios
        .post(rutaAprobarYEnviarAPago + "?prospectoId=" + this.ProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.loadingAprobarEnviarPago = false;

            if (
              this.tipoPersona == 4 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 6 ||
              this.tipoPersona == 7
            ) {
              // let figurasAdicionales =

              this.AlertaEmbajadores("El trámite ha sido preautorizado.", true);
              // if (this.tipoPersona == 4 || this.tipoPersona == 5)
              //   this.EnviarACore();
              this.CompletarProceso();
            } else {
              this.AlertaEmbajadores(
                "El trámite ha sido preautorizado y enviado para calcular el monto de pago.",
                true,
              );
            }
            this.$router.push({
              name: "AdministracionDeProspectos",
            });
          } else if (resp.data.estado === 1) {
            this.loadingAprobarEnviarPago = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.loadingAprobarEnviarPago = false;
          this.ManejarExcepcion(e);
        });
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    VerArchivo(archivoId) {
      this.urlPdf =
        window.location.origin + rutaVerArchivo + "?archivoId=" + archivoId;
    },
    AvisoFormato() {
      this.AlertaEmbajadores(
        "No se puede abrir este formato de archivo por favor descargalo para visualizarlo.",
        true,
      );
    },
    ObservacionCuestionario(obtener) {
      this.Observacion.entidadObservacion = 3;
      this.Observacion.entidadId = this.CuestionarioPersonaMoralId;
      this.Observacion.activo = true;
      if (obtener) {
        this.ObtenerObservacion(this.CuestionarioPersonaMoralId, 3);
      }
    },
    ObservacionSolicitud(obtener) {
      this.Observacion.entidadObservacion = 1;
      this.Observacion.entidadId = this.SolicitudId;
      this.Observacion.activo = true;
      if (obtener) {
        this.ObtenerObservacion(this.SolicitudId, 1);
      }
    },
    ObservacionSolicitudRepresentante(obtener) {
      this.Observacion.entidadObservacion = 2;
      this.Observacion.entidadId = this.SolicitudRepresentanteId;
      this.Observacion.activo = true;
      if (obtener) {
        this.ObtenerObservacion(this.SolicitudRepresentanteId, 2);
      }
    },
    RechazarArchivo(archivoId) {
      this.Observacion.entidadObservacion = 0;
      this.Observacion.entidadId = archivoId;
      this.Observacion.activo = true;
      this.ObtenerObservacion(archivoId, 0);
    },
    EnviarObservacionArchivo() {
      this.enviandoObservacion = true;
      this.Observacion.fechaObservacion = servicios.DarFormatoFecha(
        new Date(this.Observacion.fechaObservacion),
      );
      axios
        .post(rutaGuardarObservacionArchivo, this.Observacion)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ObservacionArchivo != null
              ? this.AlertaEmbajadores("Observación enviada.", true)
              : this.AlertaEmbajadores("Observación actualizada.", true);
            this.$refs.botoncerrarObservacion.click();
            this.cargarArchivosExpedienteProspecto();
            this.SolicitudTieneObservacion(this.ProspectoId, 1);
            this.SolicitudRepresentanteTieneObservacion(
              this.ProspectoRepresentanteLegalId,
              2,
            );
            this.CuestionarioTieneObservacion(this.ProspectoId, 3);
            this.enviandoObservacion = false;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.enviandoObservacion = false;
          this.ManejarExcepcion(e);
        });
    },
    LimpiarCamposModal() {
      this.Observacion.motivoObservacion = "";
      this.ObservacionArchivo = null;
    },
    ObtenerObservacion(entidadId, tipoEntidad) {
      const entidad = {
        params: {
          entidadId: entidadId,
          tipoEntidad: tipoEntidad,
        },
      };
      axios
        .get(rutaConsultarObservacionArchivo, entidad)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let datosObservacion = resp.data.data;
            if (datosObservacion === null) {
              this.Observacion.motivoObservacion = "";
              this.ObservacionArchivo = null;
            } else {
              this.Observacion.motivoObservacion = datosObservacion.resultado;
              this.ObservacionArchivo = datosObservacion.resultado;
              if (datosObservacion.tipoEntidad != 0) {
                switch (datosObservacion.tipoEntidad) {
                  case 1:
                    this.solicitudTieneObservacion = true;
                    break;
                  case 2:
                    this.solicitudRepresentanteTieneObservacion = true;
                    break;
                  case 3:
                    this.cuestionarioTieneObservacion = true;
                    break;
                }
              }
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    AprobarSolicitud() {
      this.AprobarArchivo(this.SolicitudId, 1);
    },
    AprobarSolicitudRepresentante() {
      this.AprobarArchivo(this.SolicitudRepresentanteId, 2);
    },
    AprobarCuestionario() {
      this.AprobarArchivo(this.CuestionarioPersonaMoralId, 3);
    },
    AprobarArchivo(entidadId, tipoEntidad) {
      axios
        .post(
          rutaEliminarObservacion +
            "?entidadId=" +
            entidadId +
            "&tipoEntidad=" +
            tipoEntidad,
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.cargarArchivosExpedienteProspecto();
            this.SolicitudTieneObservacion(this.ProspectoId, 1);
            this.SolicitudRepresentanteTieneObservacion(
              this.ProspectoRepresentanteLegalId,
              2,
            );
            this.CuestionarioTieneObservacion(this.ProspectoId, 3);
            this.AlertaEmbajadores("El archivo ha sido aprobado.", true);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    CancelarProspecto() {
      this.loadingCancelarProspecto = true;
      axios
        .post(
          rutaCancelarProspecto +
            "?prospectoId=" +
            this.ProspectoId +
            "&motivoId=" +
            this.motivoId +
            "&observacionCancelacion=" +
            this.observacionCancelacion,
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.loadingCancelarProspecto = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
            this.$refs.botoncerrarCancelacion.click();
            this.$router.push({
              name: "AdministracionDeProspectos",
            });
          } else if (resp.data.estado === 1) {
            this.loadingCancelarProspecto = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.loadingCancelarProspecto = false;
          this.ManejarExcepcion(e);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

/*Modal observación*/
.modal-dialog {
  max-width: 50%;
}
.modal-content {
  border-radius: 0px;
  border: 1px solid #707070 !important;
}
.modal-observacion__header {
  display: flex;
  justify-content: center;
  border-bottom: none;
}
.modal-observacion__titulo {
  font-family: $poppins;
  font-weight: 600;
  color: $negro-embajadores;
  text-align: center;
}
.modal-observacion__cuerpo {
  margin-top: -10px;
  padding: 30px;
}
.modal-observacion__etiqueta {
  font-family: $poppins;
  color: $negro-embajadores;
  width: 100%;
  text-align: left;
  font-weight: 500;
  padding-bottom: 5px;
}
.modal-observacion__texto {
  font-family: $poppins;
  color: $negro-embajadores;
  text-align: justify;
  height: 100px;
}
.modal-observacion__footer {
  display: flex;
  justify-content: flex-end;
  border-top: none;
}

.modal-observacion__boton {
  width: 30%;
}

.tabla-preautorizacion__td-acciones {
  display: flex;
  justify-content: center;
  align-items: center;
}

/*Panel consultas externas*/
.panel-consultas-externas {
  border: 1px solid #dcd9d9;
  border-radius: 8px;
  padding: 16px;
  height: 100%;
}
.panel-consultas-externas__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: $poppins;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #8a8a8a;
  margin-bottom: 12px;
}
.boton-motor-decision,
.boton-consulta-buro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-radius: 6px;
  font-family: $poppins;
  font-weight: 700;
  padding: 0 16px;
  margin-bottom: 10px;
}
.boton-motor-decision {
  background-color: #1f3864;
  border-color: #1f3864;
  color: $blanco;
}
.boton-consulta-buro {
  background-color: $blanco;
  border: 1px solid $gris-deshabilitado;
  color: #00917c;
}
.boton-consulta-buro--bloqueado {
  opacity: 1;
}
.boton-consulta-buro--bloqueado:disabled {
  color: #00917c;
}

@media all and (max-width: 767px) {
  .modal-dialog {
    max-width: 80%;
    margin-left: 10%;
  }
  .modal-observacion__titulo {
    font-size: 16px;
  }
  .modal-observacion__cuerpo {
    padding: 20px;
  }
  .modal-observacion__texto {
    font-size: 13px;
  }
  .modal-observacion__footer {
    flex-direction: column;
    margin-top: -10px;
  }
  .modal-observacion__boton {
    width: 60%;
  }
  .modal-observacion__etiqueta {
    font-size: 14px;
    font-weight: 700;
  }
}

tbody,
td,
tfoot,
th,
tr {
  border-style: none !important;
}
</style>





